import { FunctionComponent } from "react";
import TopNav from "../../components/navigation/TopNav";
import MobileNav from "../../components/navigation/MobileNav";
import Contact from "../../components/website/Contact";
import Footer from "../../components/website/Footer";
import NeattHeader from "../../components/website/neatt/NeattHeader";
import NeattBanner from "../../components/website/neatt/NeattBanner";
import MissionObjectives from "../../components/website/neatt/MissionObjectives";
import Credit101 from "src/components/website/neatt/Credit101";
import OpenHouse from "src/components/website/neatt/OpenHouse";


const Neatt: FunctionComponent = () => {
    return (
        <div className="max-w-[1440px] mx-auto w-full">
            <TopNav />
            <MobileNav />
            <NeattHeader />
            <NeattBanner />
            <MissionObjectives />
            <Credit101 />
            {/* <OpenHouse /> */}
            <Contact />
            <Footer />
        </div>  
    );
};


export default Neatt;


